// ======================================================================
// File Name       : ContentQuestionRegisterAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/question';
import { ANSWER_FORMULA_NUM } from '../../constants/ContentConstant';
import { commonCallApi } from '../../utils/ApiUtils';
import { escapeHtml } from '../../utils';

export function RegisterQuestion({
  questionSecernId,
  questionTitle,
  questionAttributeScope,
  hintUse,
  hintContent,
  hintHtmlUse,
  hintZipFileName,
  hintZipFile,
  questionUseForm,
  questionZipFileName,
  questionZipFile,
  explanationUse,
  explanationContent,
  explanationHtmlUse,
  explanationZipFile,
  explanationZipFileName,
  subQuestionArray,
  limitTime,
  questionKind,
}) {
  return (dispatch) => {
    const param = {};
    const questionInfo = {};
    questionSecernId && (questionInfo.questionSecernId = questionSecernId);
    questionTitle && (questionInfo.questionTitle = questionTitle);
    questionAttributeScope && (questionInfo.questionAttributeScope = questionAttributeScope);
    subQuestionArray && (questionInfo.subQuestionArray = subQuestionArray);
    limitTime && (questionInfo.limitTime = parseInt(limitTime, 10));
    // question
    questionInfo.questionUseForm = 1;
    questionInfo.questionZipFileName = questionZipFileName;
    param.questionZipFile = questionZipFile;
    // explanation
    explanationUse !== null && (questionInfo.explanationUse = (explanationUse == '1' ? 1 : 0));
    explanationHtmlUse !== null && (questionInfo.explanationHtmlUse = (explanationHtmlUse == '1' ? 1 : 0));
    if (questionInfo.explanationUse === 1) {
      if (questionInfo.explanationHtmlUse === 1) {
        param.explanationZipFile = explanationZipFile;
        questionInfo.explanationZipFileName = explanationZipFileName;
      } else {
        questionInfo.explanationHtmlUse = 0;
        questionInfo.explanationContent = escapeHtml(explanationContent); // #6818
      }
    } else {
      questionInfo.explanationUse = 0;
    }
    // hint
    hintUse !== null && (questionInfo.hintUse = (hintUse == '1' ? 1 : 0));
    hintHtmlUse !== null && (questionInfo.hintHtmlUse = (hintHtmlUse == '1' ? 1 : 0));
    if (questionInfo.hintUse === 1) {
      if (questionInfo.hintHtmlUse === 1) {
        questionInfo.hintZipFileName = hintZipFileName;
        param.hintZipFile = hintZipFile;
      } else {
        questionInfo.hintHtmlUse = 0;
        questionInfo.hintContent = hintContent;
      }
    } else {
      questionInfo.hintUse = 0;
    }

    param.questionInfo = questionInfo;
    dispatch(registerNewBigQuestion(param));
  };
}

function registerNewBigQuestion(param) {
  return (dispatch) => {
    commonCallApi({
      path: 'PartsQuestionRegister',
      data: param,
      muiltipart: 1,
      drillServer: true,
    })
      .then((resdata) => {
        dispatch(receiveResponse(resdata, ActionTypes.REGISTER_NEW_BIG_QUESTION));
      });
  };
}

export function contentSingleQuestionRegister({
  questionSecernId,
  questionTitle,
  questionAttributeScope,
  answerFormula,
  sankakuUseDistinct,
  absolutePoint,
  limitTime,
  hintUse,
  hintContent,
  hintHtmlUse,
  hintZipFileName,
  hintZipFile,
  questionUseForm,
  questionViewDirection,
  questionContent,
  questionZipFileName,
  questionZipFile,
  optionMarkKind,
  optionRandomUse,
  correctNumber,
  correctAnswer,
  inputLimit,
  inputLimitType,
  optionArray,
  explanationUse,
  explanationContent,
  explanationHtmlUse,
  explanationZipFileName,
  explanationZipFile,
}) {
  return (dispatch) => {
    const param = {};
    const questionInfo = {};
    questionSecernId && (questionInfo.questionSecernId = questionSecernId);
    questionTitle && (questionInfo.questionTitle = escapeHtml(questionTitle)); // #6818
    questionAttributeScope && (questionInfo.questionAttributeScope = questionAttributeScope);
    questionInfo.sankakuUseDistinct = sankakuUseDistinct ? 1 : 0;
    !isNaN(absolutePoint) && (questionInfo.absolutePoint = parseInt(absolutePoint, 10));
    !isNaN(limitTime) && (questionInfo.limitTime = parseInt(limitTime, 10));
    questionInfo.inputLimitType = inputLimitType ? 1 : 0;
    questionInfo.inputLimit = null;
    if (inputLimitType) {
      questionInfo.inputLimit = parseInt(inputLimit, 10);
    }

    // question
    questionUseForm !== null && (questionInfo.questionUseForm = (questionUseForm == '1' ? 1 : 0));
    if (questionInfo.questionUseForm === 1) {
      questionInfo.questionZipFileName = questionZipFileName;
      param.questionZipFile = questionZipFile;
    } else {
      questionInfo.questionUseForm = 0;
      questionInfo.questionContent = questionContent;
      questionViewDirection &&
        (questionInfo.questionViewDirection = parseInt(questionViewDirection, 10));
      !isNaN(optionMarkKind) && (questionInfo.optionMarkKind = parseInt(optionMarkKind, 10));
      !isNaN(optionRandomUse) && (questionInfo.optionRandomUse = (optionRandomUse == '1' ? 1 : 0));
      !isNaN(answerFormula) && (questionInfo.answerFormula = parseInt(answerFormula, 10));
      // check answerFormula = 3,4,5,6,7 set the answer to param correct_answer
      if (!isNaN(questionInfo.answerFormula)) {
        if (questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER ||
          questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER ||
          questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT ||
          questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER ||
          questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER) {
          correctAnswer && (questionInfo.correctAnswer = correctAnswer);
          questionInfo.correctNumber = '';
          questionInfo.optionArray = [];
        } else {
          questionInfo.correctAnswer = '';
          // #6818 START
          if (optionArray) {
            const optionArrayEscapeHtml = optionArray.reduce((acc, cur) => {
              cur.optionContent = escapeHtml(cur.optionContent);
              acc.push(cur);
              return acc;
            }, []);
            questionInfo.optionArray = optionArrayEscapeHtml;
          }
          // #6818 END
          correctNumber && (questionInfo.correctNumber = correctNumber);
        }
      }
    }
    // explanation
    explanationUse !== null && (questionInfo.explanationUse = (explanationUse == '1' ? 1 : 0));
    explanationHtmlUse !== null && (questionInfo.explanationHtmlUse = (explanationHtmlUse == '1' ? 1 : 0));
    if (questionInfo.explanationUse === 1) {
      if (questionInfo.explanationHtmlUse === 1) {
        param.explanationZipFile = explanationZipFile;
        questionInfo.explanationZipFileName = explanationZipFileName;
      } else {
        questionInfo.explanationHtmlUse = 0;
        questionInfo.explanationContent = escapeHtml(explanationContent); // #6818
      }
    } else {
      questionInfo.explanationUse = 0;
    }
    // hint
    hintUse !== null && (questionInfo.hintUse = (hintUse == '1' ? 1 : 0));
    hintHtmlUse !== null && (questionInfo.hintHtmlUse = (hintHtmlUse == '1' ? 1 : 0));
    if (questionInfo.hintUse === 1) {
      if (questionInfo.hintHtmlUse === 1) {
        questionInfo.hintZipFileName = hintZipFileName;
        param.hintZipFile = hintZipFile;
      } else {
        questionInfo.hintHtmlUse = 0;
        questionInfo.hintContent = hintContent;
      }
    } else {
      questionInfo.hintUse = 0;
    }
    param.questionInfo = questionInfo;
    dispatch(sendNewSingleQuestionRegister(param));
  };
}

function sendNewSingleQuestionRegister(param) {
  return (dispatch) => {
    commonCallApi({
      path: 'QuestionRegister',
      data: param,
      muiltipart: 1,
      drillServer: true,
    }).then((resdata) => {
      dispatch(receiveResponse(resdata, ActionTypes.REGISTER_NEW_SINGLE_QUESTION));
    });
  };
}

function receiveResponse(resdata, type) {
  return {
    type,
    resdata,
  };
}
